@let reviewForm = form();

<div [formGroup]="reviewForm">
  <app-pan-form-control>
    <app-pan-floating-label [required]="isRequired()">Screenshot of Transaction Report</app-pan-floating-label>

    <app-pan-filepicker
      #uploadField
      [previewUrls]="imageUrls()"
      (selected)="upload.emit($event)"
      (remove)="removeImageUrl($event)"
      data-testid="reportsDropzone"
    >
      <ng-template let-url let-remove="remove">
        <app-pan-image-preview-button [src]="url" [alt]="''" [modalTitle]="'Transaction Report'" [modalTopLevel]="false">
          <ng-container footerActions>
            <swal
              #removeSwal
              title="Remove file?"
              text="Are you sure you want to remove this file?"
              icon="warning"
              confirmButtonText="Yes, Remove"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="remove()"
            >
            </swal>

            <app-pan-button color="danger" [swal]="removeSwal">Remove</app-pan-button>
          </ng-container>
        </app-pan-image-preview-button>
      </ng-template>
    </app-pan-filepicker>

    <div class="gap-2 flex flex-row flex-wrap mt-3">
      @for (file of reviewForm.controls.existingReports.value; track $index) {
        <app-pan-image-preview-button [src]="file" [alt]="''" [modalTitle]="'Transaction Report'" [modalTopLevel]="false">
          <ng-container footerActions>
            <swal
              #removeExistingReportSwal
              title="Remove file?"
              text="Are you sure you want to remove this file?"
              icon="warning"
              confirmButtonText="Yes, Remove"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="removeLink(file)"
            >
            </swal>

            <app-pan-button color="danger" [swal]="removeExistingReportSwal">Remove</app-pan-button>
          </ng-container>
        </app-pan-image-preview-button>
      }
    </div>
  </app-pan-form-control>
</div>
